var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaveActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 26,
    viewBox: "0 0 23 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 23.5568V2C1 1.44772 1.44772 1 2 1H21C21.5523 1 22 1.44771 22 2V23.5568C22 24.3702 21.0806 24.8433 20.4188 24.3705L12.0812 18.4152C11.7335 18.1668 11.2665 18.1668 10.9188 18.4152L2.58124 24.3705C1.91937 24.8433 1 24.3702 1 23.5568Z",
    stroke: "#000000",
    fill: "#000000",
    strokeWidth: 1.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveActive);
export default __webpack_public_path__ + "static/media/save-active.899602661390acd48dd6dc1480aa295d.svg";
export { ForwardRef as ReactComponent };